import { Component, Input } from '@angular/core';
import { TreeViewItem } from '../../models/tree-view-item.interface';
import { TreeViewGroupComponent } from '../tree-view-group/tree-view-group.component';
import { TreeViewItemComponent } from '../tree-view-item/tree-view-item.component';

@Component({
    selector: 'fk-tree-view',
    templateUrl: './tree-view.component.html',
    styleUrls: ['./tree-view.component.scss'],
    imports: [TreeViewGroupComponent, TreeViewItemComponent],
})
export class TreeViewComponent {
  @Input()
  items!: TreeViewItem[];

  @Input()
  minimized = false;

  protected isGroup(item: TreeViewItem): boolean {
    return Boolean(item.items);
  }
}
